
import Vue from 'vue';
import Component from 'vue-class-component';
import { LocalStorage } from '../../core/localStorage';
import store from '../../core/store';
import { ShopService } from '../../core/services/shopService';
import { CustomerHelper } from '../../crm/helpers/customerHelper';
import { Settings } from "@shared/core/services/configService";
import { CrudService } from "../../core/services/crudService";

@Component({
  components: {},
})
export default class MenuUpper extends Vue {
  currentLanguage: any = '';
  customer: any = null;
  errorMessage: string | null = null;

  async mounted() {
    let cid = CustomerHelper.getStoredCustomer();
    if (cid !== undefined) {
      this.customer = await CustomerHelper.getCustomerData(cid);
    }

    this.currentLanguage = LocalStorage.get('lcl');
    this.currentLanguage =
      this.currentLanguage === null || this.currentLanguage === undefined
        ? 'es-ES'
        : this.currentLanguage;
  }

  selectLanguage(language: any) {
    this.currentLanguage = language;
    LocalStorage.add('lcl', language);
    this.$router.go(0);
  }

  getClass(language: any, hasDivider: boolean) {
    let c: any = 'nav-link nav-transparent nav-text-small h-100 pt-2';
    c += hasDivider ? ' nav-divider' : '';
    c += hasDivider ? '' : ' pr-3';
    c += this.currentLanguage !== language ? ' nav-inactive' : '';
    return c;
  }

  getClassLogin() {
    return 'auth-link-button';
  }

  getClassRegister() {
    return 'auth-link-button';
  }

  getClassSelect() {
    return 'auth-link-select';
  }

  logInOut(login: any) {
    if (store.state.loggedIn !== true) {
      LocalStorage.add('loginModeOn', login);
      store.commit('openLogin', { backUrl: window.location.pathname });
      return;
    }
    new ShopService().removeCart();
    CustomerHelper.logOut();
    window.location.reload();
  }

  onChildSelected(event: Event) {
    const selectedId = parseInt((event.target as HTMLSelectElement).value);
    if (selectedId !== this.customer.id) {
      this.impersonateChild(selectedId);
    }
  }

  async impersonateChild(childId: number) {
    try {
      const url = `${Settings.HostName}/api/publiccustomers/impersonate`;

      const response = await new CrudService().httpPost(url, childId);

      if (response && response.token) {
        CustomerHelper.saveLogedCustomer(
          response.token,
          null,
          response.customer.id,
          null,
          response.customer.name,
          response.customer.surname
        );

        this.$router.go(0);
      }else{
        this.errorMessage = response
      }
    } catch (error) {
      console.error("Failed to impersonate child", error);
    }
  }

}
